export default "__VITE_ASSET__gvfSpCGU75YjSsAK0VWPbA__"